import {scheduledReportType, storeTableDataMapValue} from './model'
import ScheduledTableData from './ScheduledTableData'
import {convertTableMapDataToTable} from './utils'

type TableWrapperProps = {
  tableDataMap: Map<string, storeTableDataMapValue>
  selectedClient: string
  selectedSite: string
  shifts: Set<string>
}

const TableWrapper = ({tableDataMap, selectedClient, selectedSite, shifts}: TableWrapperProps) => {
  let tableData: scheduledReportType[] = convertTableMapDataToTable({
    shifts,
    selectedClient,
    selectedSite,
    tableDataMap,
  })
  return tableData.length > 0 ? <ScheduledTableData tableData={tableData} /> : null
}

export default TableWrapper
{
  /*
    return {
            checkpoints: checkPoints.size,
            expectedScans: total,
            missedScans: missed,
            shift: shiftName,
            successfulScans: scheduled,
            successScanPercentage: `${(scheduled / total)?.toFixed(2)}%`,
          }
    */
}
